import { usePunditUserContext } from "@circle-react/contexts";

export const useIsAiAutomationsV2Enabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.ai_automations_v2_enabled);
};
